<div class="text-ellipsis grid-cell" show-tooltip (dblclick)="onDbClick()">
    {{ fieldValue }}
</div>